import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type { RewardsEarningRulesResponse } from "../models/RewardsEarningRulesEntities";
import { RewardsEarningRulesResponseSchema } from "../models/RewardsEarningRulesSchemas";
import type { RewardsEarningRulesQueryParams } from "../types";

@singleton()
class RewardsEarningRulesApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    getEarningRules(
        queryParams: RewardsEarningRulesQueryParams
    ): Observable<RewardsEarningRulesResponse> {
        return this.apiClient
            .get({
                url: "/points/getEarningRules",
                queryParams,
                responseType: "json",
            })
            .pipe(
                map((value) =>
                    create(value.body, RewardsEarningRulesResponseSchema)
                )
            );
    }
}

export default RewardsEarningRulesApiService;
